import React, { useContext } from 'react';

import { CustomTextContext } from 'context/CustomTextContext';
import StyledHtmlBody from './StyledHtmlBody';
import overrideStyle from 'lib/overrideStyle';

export default function OfficeHourDisplay() {
  const { officeHourMessage } = useContext(CustomTextContext);
  return (
    <OfficeHour>
      <StyledHtmlBody body={officeHourMessage} />
    </OfficeHour>
  );
}

const OfficeHour = overrideStyle('div')`
  align-self: ${p => (p.theme.isMobileSdk ? 'center' : 'inherit')};
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding-top: ${p => (p.theme.isMobileSdk ? '40px' : '0px')};
`;
